import type { ClientType } from '@/components/Views/Company/File/file.types';
import { ClientTypeEnum } from '@/components/Views/Company/File/file.types';

export const isBuyerOrSeller = (role: ClientType): boolean => role === ClientTypeEnum.BUYER || role === ClientTypeEnum.SELLER;
